import firebase from "firebase/app"
import "firebase/auth"

const firebaseConfig = {
  apiKey: "AIzaSyDMgET32EEuqeRW6PuCFcYDe-dA9J91KkQ",
  authDomain: "ms-ty-7cc51.firebaseapp.com",
  databaseURL: "https://ms-ty-7cc51.firebaseio.com",
  projectId: "ms-ty-7cc51",
  storageBucket: "ms-ty-7cc51.appspot.com",
  messagingSenderId: "704886037980",
  appId: "1:704886037980:web:950c6cbb3616aff9f0c319",
}

firebase.initializeApp(firebaseConfig)

export default firebase
